import {
    createStore,
    applyMiddleware,
} from 'redux';
import logger from 'redux-logger';
import thunk from 'redux-thunk';
import promise from 'redux-promise-middleware';
import appReducer from './appReducer';
import appSettings from '../config/appSettings';

const store = (!appSettings.production && appSettings.reduxLogger)
    ? createStore(
        appReducer,
        {},
        applyMiddleware(
            logger,
            thunk,
            promise(),
        ),
    )
    : createStore(
        appReducer,
        {},
        applyMiddleware(
            thunk,
            promise(),
        ),
    );

export default store;



// WEBPACK FOOTER //
// ./src/app/store.js